export const setActiveStockCart = (state, payload) => {
  state.activeCart = payload
}

export const setActiveContainerCart = (state, payload) => {
  state.activeContainerCart = payload
}

export const setActiveRetailCart = (state, payload) => {
  state.activeRetailCart = payload
}

export const setCartStockQty = (state, payload) => {
  state.cartStockQty = payload
}

export const setCartRetailQty = (state, payload) => {
  state.cartRetailQty = payload
}

export const setCartContainerQty = (state, payload) => {
  state.cartContainerQty = payload
}

export const setCurrentStoreType = (state, payload) => {
  state.currentStoreType = payload
}

export const setCartItemsTracker = (state, payload) => {
  state.cartItemsTracker = payload
}

export const updateActiveStockCart = (state, payload) => {
  Object.assign(state.activeCart, payload)
}

export const updateActiveContainerCart = (state, payload) => {
  Object.assign(state.activeContainerCart, payload)
}

export const updateActiveRetailCart = (state, payload) => {
  Object.assign(state.activeRetailCart, payload)
}

export const updateCartStockQty = (state, payload) => {
  Object.assign(state.cartStockQty, payload)
}

export const updateCartRetailQty = (state, payload) => {
  Object.assign(state.cartRetailQty, payload)
}

export const updateContainerStockQty = (state, payload) => {
  Object.assign(state.cartContainerQty, payload)
}

export const updateCartItemsTracker = (state, payload) => {
  Object.assign(state.cartItemsTracker, payload)
}

export const setLoaded = (state, payload) => {
  state.loaded = payload
}